export default {"src":"/_next/static/media/empty-card.4703d9de.svg","height":200,"width":172};